import { IconWrapper } from '../runtime';
export default IconWrapper('folder-shared-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M2.25 20.25C1.00736 20.25 0 19.2426 0 18L0 3C0 1.75736 1.00736 0.75 2.25 0.75L6.75 0.75C7.23683 0.75 7.71053 0.9079 8.1 1.2L9.9 2.55C10.2895 2.8421 10.7632 3 11.25 3L21.75 3C22.9926 3 24 4.00736 24 5.25L24 18C24 19.2426 22.9926 20.25 21.75 20.25L2.25 20.25Z",
      "fill": "#317FF2"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.25 22.5C1.00736 22.5 0 21.4926 0 20.25L0 7.5C0 6.25736 1.00736 5.25 2.25 5.25L21.75 5.25C22.9926 5.25 24 6.25736 24 7.5L24 20.25C24 21.4926 22.9926 22.5 21.75 22.5L2.25 22.5Z",
      "fill": 'url(#' + props.id + '9974dcdb' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16.6875 10.3125C16.6875 11.2963 15.89 12.0938 14.9062 12.0938C14.4475 12.0938 14.0293 11.9204 13.7136 11.6356L11.7031 12.7758C11.7742 13.0046 11.8125 13.2478 11.8125 13.5C11.8125 13.7752 11.7669 14.0398 11.6828 14.2866L13.6834 15.486C14.0025 15.1847 14.4328 15 14.9062 15C15.89 15 16.6875 15.7975 16.6875 16.7812C16.6875 17.765 15.89 18.5625 14.9062 18.5625C13.9225 18.5625 13.125 17.765 13.125 16.7812C13.125 16.678 13.1338 16.5768 13.1507 16.4783L11.0832 15.2388C10.6434 15.6709 10.0403 15.9375 9.375 15.9375C8.02881 15.9375 6.9375 14.8462 6.9375 13.5C6.9375 12.1538 8.02881 11.0625 9.375 11.0625C10.0639 11.0625 10.6861 11.3483 11.1294 11.8078L13.1583 10.6571C13.1365 10.5456 13.125 10.4304 13.125 10.3125C13.125 9.32874 13.9225 8.53125 14.9062 8.53125C15.89 8.53125 16.6875 9.32874 16.6875 10.3125Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '9974dcdb',
      "x1": "2.25",
      "y1": "6.43828",
      "x2": "19.1823",
      "y2": "24.658",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#30B3FD"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#5589FF"
    }
  })])])]);
});